import { Heart } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface FavoritesToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function FavoritesToggle({
  checked,
  onCheckedChange,
}: FavoritesToggleProps) {
  return (
    <div className="flex items-center gap-3">
      <Checkbox
        id="favorites-toggle"
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="border-2 border-pink-400 data-[state=checked]:bg-pink-400 data-[state=checked]:border-pink-400"
      />
      <Label
        htmlFor="favorites-toggle"
        className="text-sm font-medium cursor-pointer flex items-center gap-2"
      >
        <Heart
          className="w-4 h-4 text-pink-400"
          fill={checked ? "currentColor" : "none"}
        />
        Favorites only
      </Label>
    </div>
  );
}
